var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgModules = function SvgModules(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    d: "M9 22h6M12 21v-3M20.218 2.542l1.774 13.769a.5.5 0 0 1-.023.257.6.6 0 0 1-.158.226.8.8 0 0 1-.263.153 1 1 0 0 1-.32.053H2.774a1 1 0 0 1-.326-.058.8.8 0 0 1-.265-.16.6.6 0 0 1-.156-.233.5.5 0 0 1-.018-.263l1.873-13.77a.62.62 0 0 1 .271-.369.93.93 0 0 1 .51-.147H19.5c.18.01.351.07.483.17a.58.58 0 0 1 .235.372M20.5 7h-17M21 12H3M8 17 9 2M16 17 15 2"
  })));
};
export default SvgModules;